import React from 'react';
import * as d3 from 'd3';
import '../css/Text.css';

export default class TextChart extends React.Component {
	constructor(props) {
      super(props)
      this.state = {
      	text: null,
      }
      
      this.anchor = React.createRef();
    }

    componentDidMount() {
    	const url = ["https://aukt2i8vp5.execute-api.us-east-1.amazonaws.com/Prod/main"]
	    const opts = {"type": "findOneTweet", "airline": "", "isAll": true};

	    Promise.all([
	      fetch(url[0], {
	        method: 'post',
	        body: JSON.stringify(opts)
	      })
	      .then(data => data.json())
	      .catch((e) => console.log(e)),
	    ])
	    .then((results) => {
	      
	      const data = JSON.parse(JSON.parse(results[0].tweets));
	      
	      // console.log(text)
	      const tweets = data.text
	      // console.log(tweets)
	      this.setState({text: tweets.split()})
	      this.setBar()
	      this.updateAvgDelay(this.state.text);	
	    });
    	
    }

    componentDidUpdate() {
    	if (this.props.text === null) {
    		this.updateAvgDelay(this.state.text);	
    	}
    	else {
    		this.updateAvgDelay(this.props.text);
    	}
    }

    updateAvgDelay(tweet) {
    	const data = tweet

    	const g = d3.select('#text-g')
    	var t = d3.transition()
		  .duration(750);

		// JOIN new data with old elements.
		var text = g.selectAll("text")
		.data(data, function(d) {return d; });
		
		// EXIT old elements not present in new data.
		text.exit()
		  .attr("class", "exit")
		.transition(t)
		  .attr("y", 60)
		  .style("fill-opacity", 1e-6)
		  .style('fill', "brown")
		  .remove();

		// UPDATE old elements present in new data.
		text.attr("class", "update")
		  .attr("y", 0)
		  .style("fill-opacity", 1)
		  .style('fill', "#333")
		.transition(t)
		  .attr("x", function(d, i) { return i * 32; });

		// ENTER new elements present in new data.
		text.enter().append("text")
		  .attr("class", "enter")
		  .attr("dy", ".35em")
		  .attr("y", -60)
		  .attr("x", function(d, i) { return i * 32; })
		  .style("fill-opacity", 1e-6)
		  .style('fill', "green")
		  .style('font', "bold 20px monospace")
		  .text(function(d) { return d; })
		.transition(t)
		  .attr("y", 0)
		  .style("fill-opacity", 1);

    }

    setBar() {
    	const width = 1800;
    	const height = 100;

		var svg = d3.select(this.anchor.current)
					.append('svg')
					.attr('width', width)
					.attr('height', height)
					.attr("id", 'svg-text')
		    
		svg.append("g")
					.attr("transform", "translate(100," + (height / 2) + ")")
					.attr("id", "text-g");
		
    }

    

    render() {
    	return(
    		<React.Fragment>
    		<div ref={this.anchor} />
    		</React.Fragment>
    	);
    }
}